module.exports = __webpack_public_path__ + "static/media/no-questions.3cda7997.png";